import { ACTION_TYPES, MAX_SHARED_FILES_RESULTS } from '~/core/constants'
import { fetchSharedFiles } from '~/services/shared-files'
import { selectHasMorePages, getFetchingInProgress, selectLastSharedFilesPageIndex } from '~/selectors/shared-files'
import { batch } from 'react-redux'
import { getViewedSessionId } from '~/selectors/ui'

const { SHARED_FILES } = ACTION_TYPES

const fetchedSharedFiles = payload => ({
  type: SHARED_FILES.FETCHED_SHARED_FILES,
  payload
})

export const setFetchingInProgress = ({ sessionId, value }) => ({
  type: SHARED_FILES.FETCHING_IN_PROGRESS,
  payload: { sessionId, value }
})

export const purgeSharedFilesData = sessionId => ({
  type: SHARED_FILES.PURGE_SHARED_FILES_DATA,
  payload: { sessionId }
})

export const getSharedFiles = sessId => async (
  dispatch,
  getState
) => {
  const sessionId = sessId || getViewedSessionId(getState())
  const fetchingInProgress = getFetchingInProgress(sessionId)(getState())

  if (fetchingInProgress) {
    return
  }

  const hasMoreSharedFiles = selectHasMorePages(sessionId)(getState())
  const lastSharedFilesPageIndex = selectLastSharedFilesPageIndex(sessionId)(getState())

  if (!hasMoreSharedFiles) {
    return
  }

  dispatch(setFetchingInProgress({ sessionId, value: true }))

  const response = await fetchSharedFiles(
    sessionId,
    lastSharedFilesPageIndex,
    MAX_SHARED_FILES_RESULTS
  )

  batch(() => {
    dispatch(setFetchingInProgress({ sessionId, value: false }))
    dispatch(fetchedSharedFiles(response))
  })
}
